import script from "./BuyerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerModal.vue?vue&type=script&setup=true&lang=js"

import "./BuyerModal.vue?vue&type=style&index=0&id=017a910f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017a910f"]])

export default __exports__